"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSM_TEMPLATES = exports.SSM_TEMPLATES_MD = void 0;
exports.SSM_TEMPLATES_MD = {
    'Kickstart Meeting (KSM)': `* Introduction (5 mins)\n
* Introduce the Crimson team and services (5-10 mins)\n
* Quickfire round of questions (5 minutes)\n
* Crimson App recap (5 minutes)\n
* Information Gathering (25 to 30 minutes)\n
* Contact information (5 mins)\n
* Next steps (5 mins)`,
    'Milestone Meeting 1': `* Introduce the Timeline for the coming year\n
* Milestone Meeting schedule for this year\n
* Expectation Setting\n
* Discussion of Key Events & Dates\n
* Holiday Plans\n
* Service Usage\n
* Team member or meeting changes where applicable`,
    'Milestone Meeting 2': `* Discussion of Key Events & Dates\n
* Holiday Plans\n
* Goal Checkin\n
* Service Usage\n
* Key Date Reminder`,
    'Milestone Meeting 3': `* Discussion of Key Events & Dates\n
* Holiday Plans\n
* Goal Checkin\n
* Service Usage\n
* Wellness Check\n
* Feedback\n
* Key Date Reminder`,
    'Milestone Meeting 4': `* Discussion of Key Events & Dates\n
* Holiday Plans\n
* Goal Checkin\n
* Service Usage\n
* Wellness Check\n
* Feedback\n
* Key Date Reminder`,
    'Parent Alignment': `* Intro - who is in the room (if applicable)\n
* Agenda\n
* Agreement of intended meeting outcome\n
* Discussion / Information sharing\n
* Summary of key points & agreements`,
    'Student Ad Hoc Support': `* No fixed agenda`,
    'RISE: Parent Meeting': `* REMIND - Parents of:\n
\t* This month's Strategy focus + tasks(remind them to be checking in with their students about what they're learning and reinforcing what the Strat is working on)\n
\t* this month's upcoming Rise Community event(remind them to check in with their kids--and please ask them if the times aren't feasible)\n
\t* this month's Rise Readers Newsletter(with book and vocab recs)\n
* SHARE - Feedback or updates from tutors\n
* COLLECT - Feedback or concerns from families, positive growth they're noticing, relay to team`,
    'RISE: Wrap Up': `* Meeting agenda\n
* Goal & progress review\n
* Feedback & Observations\n
* Next steps`,
    'Strategist Introduction': `* Introducing new Strategist\n
* Student status update\n
* Questions from the family\n
* Next steps`,
    Other: '* N/A',
};
exports.SSM_TEMPLATES = {
    'Kickstart Meeting (KSM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introduction (5 mins)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Introduce the Crimson team and services (5-10 mins)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Quickfire round of questions (5 minutes)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Crimson App recap (5 minutes)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Crimson App recap (5 minutes)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Information Gathering (25 to 30 minutes)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Contact information (5 mins)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Next steps (5 mins)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Milestone Meeting 1': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introduce the Timeline for the coming year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Milestone Meeting schedule for this year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Expectation Setting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Discussion of Key Events & Dates',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Holiday Plans',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Service Usage',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Team member or meeting changes where applicable',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Milestone Meeting 2': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of Key Events & Dates',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Holiday Plans',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Goal Checkin',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Service Usage',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Key Date Reminder',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Milestone Meeting 3': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of Key Events & Dates',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Holiday Plans',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Goal Checkin',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Service Usage',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Wellness Check',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Feedback',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Key Date Reminder',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Milestone Meeting 4': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of Key Events & Dates',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Holiday Plans',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Goal Checkin',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Service Usage',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Wellness Check',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Feedback',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Key Date Reminder',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Parent Alignment': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Intro - who is in the room (if applicable)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Agenda',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Agreement of intended meeting outcome',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Discussion / Information sharing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Summary of key points & agreements',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Student Ad Hoc Support': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'No fixed agenda',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'RISE: Parent Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'REMIND - Parents of:',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: "This month's Strategy focus + tasks(remind them to be checking in with their students about what they're learning and reinforcing what the Strat is working on)",
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: "this month's upcoming Rise Community event(remind them to check in with their kids--and please ask them if the times aren't feasible)",
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: "this month's Rise Readers Newsletter(with book and vocab recs)",
                },
            ],
            listStyleType: 'disc',
            indent: 2,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'SHARE - Feedback or updates from tutors',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: "COLLECT - Feedback or concerns from families, positive growth they're noticing, relay to team",
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'RISE: Wrap Up': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Meeting agenda',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Goal & progress review',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Feedback & Observations',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Next steps',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Strategist Introduction': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introducing new Strategist',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Student status update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Questions from the family',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Next steps',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=ssm.js.map